import { TemplateResult } from 'lit';

export interface HeaderMenuItem {
  id: string;
  icon: string;
  name: string;
  isActive: boolean;
  disableAutoClearActive?: boolean;
  isVisible: boolean;
  handler?: Function;
  content?: TemplateResult;
  badgeContent?: number;
}

export interface UserRoleDependencies {
  userName: string;
  navigateToMyAccount: () => void;
  navigateToMyCompany: () => void;
  navigateToMyIntegrations: () => void;
  navigateToCredentialsManager: () => void;
  logoutUser: () => void;
  showFeedbackForm: () => void;
  showSupportPanel: () => void;
  handleDarkTheme: () => void;
}

export interface UserFeaturesAndRights {
  manageCompanies: boolean;
  manageInventory: boolean;
  companyManager: boolean;
  manageReports: boolean;
  companion: boolean;
  sve_service: boolean;
  eps_service: boolean;
}

export enum HeaderItemEvents {
  MENU_OPEN = 'menuItemOpen',
}

export enum FeaturesConstants {
  COMPANION_STANDALONE = 0x0f3700,
  SVE_SERVICE = 0x0f0201,
  EPS_SERVICE = 0x0f0101,
}
